import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

const triangleLength = 12;
const tooltipWidth = 188;
const tooltipHeight = 71;

const useStyles = makeStyles((theme) => ({
  tooltip: {
    backgroundColor: "#FFF8F2",
    borderRadius: 10,
    padding: 16,
    width: tooltipWidth,
    height: tooltipHeight,
    boxSizing: "border-box",
    boxShadow: `inset 0px 0px 0px 2px #EF8646`,
    filter: "drop-shadow(0px 8px 12px rgba(254, 139, 6, 0.19))",
  },
  triangle: {},
  triangleright: {
    content: '""',
    display: "block",
    position: "absolute",
    width: triangleLength,
    height: triangleLength,
    backgroundColor: "#FFF8F2",
    boxShadow: `inset -4px 4px 0px -2px #EF8646`,
    transform: "translateY(-50%) translateX(-50%) rotate(-45deg)",
    zIndex: 0,
  },
  body: {
    color: theme.palette.text.primary,
    fontSize: 16,
  },
}));

const RemediationReminder: React.FC<any> = () => {
  const classes = useStyles();

  const getTriangle = () => {
    let posXOffset = 28;
    let posYOffset = 0;

    let className = classes.triangleright;

    return (
      <Box
        className={`${classes.triangle} ${className}`}
        sx={{
          position: "absolute",
          left: `${posXOffset}px`,
          top: `${posYOffset}px`,
        }}></Box>
    );
  };

  return (
    <Box
      className={classes.tooltip}
      sx={{
        position: "absolute", // Use 'fixed' or 'absolute' depending on the layout context
        left: `-8px`,
        bottom: `-82px`,
        zIndex: 1000,
      }}>
      {getTriangle()}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}>
        <Typography variant="h4" className={classes.body}>
          Watch recommended lesson videos here
        </Typography>
      </Box>
    </Box>
  );
};

export default RemediationReminder;
